import React, { Component } from "react";
import PropTypes from "prop-types";
import { observer, inject } from "mobx-react";
import { Button, Modal, Toastr } from "arv-reactcomponents";
import { toJS } from "mobx";
import lodashGet from "lodash.get";
import { Endpoints, REVIEW } from "npmlinks-constants";
import GetRating from "../GetRating";

@inject("ProductStore", "LoginStore", "CommonStore", "ReviewStore") //"ReviewStore"
@observer
class ViewReviewPage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedFile: null,
      total: 0,
      review: "",
      file: [],
      files: [],
      urls: [],
      links: [],
      reviewConfig: {},
      value: ""
    };
  }

  render() {
    const {
      productTitle,
      productDescription,
      image,
      reviews,
      color,
      size,
      updateReview,
      reviewStatus
    } = this.props;
    const { PdpData } = this.props.ProductStore;

    return (
      <div className="nw-fill-review-container">
        <div className="nw-fill-reviewheading">{REVIEW.VIEW_REVIEW}</div>
        <div className="nw-nw-review-productmainimagecontainer">
          <img className="nw-review-productmainimage" src={image} alt="nnnow" />
          <div className="nw-review-producttitlecontainer">
            <div className="nw-review-productbrand">{productTitle}</div>
            <div className="nw-review-productname">{productDescription}</div>
            <div className="nw-review-productbrand">
              {REVIEW.REVIEW_COLOR} : {color}
            </div>
            <div className="nw-review-productbrand">
              {REVIEW.REVIEW_SIZE} : {size}
            </div>
          </div>
        </div>
        {reviewStatus && reviewStatus === "UNDER_MODERATION" && (
        <div className="nw-review-alertbox-container">
          <i className="nw-alertbox-icon icomoon-clock" />
          <div className="nw-alertbox-title">{REVIEW.MODERATION}</div>
        </div>
        ) || null}
        {reviewStatus && reviewStatus === "PUBLISHED" && (
        <div className="nw-review-alertbox-publishcontainer">
        <img className="nw-alertbox-icon nw-review-published" src={Endpoints.ratings.published} alt="published"/>
          <div className="nw-alertbox-title">{REVIEW.PUBLISHED}</div>
        </div>
        )|| null}
        {reviewStatus && reviewStatus === "REJECTED" && (
        <div className="nw-review-alertbox-rejectcontainer">
          <i className="nw-alertbox-icon nw-review-rejected icomoon-notification" />
          <div className="nw-alertbox-title">{REVIEW.REJECTED}</div>
        </div>
        )|| null}
        <div className="nw-review-subheaderviewreview">
          {REVIEW.RATING}
        </div>
        <div className="nw-review-ratingheader">
          <GetRating.component
            isShowRating={true}
            rating={reviews.rating}
            starSize="24px"
          />
        </div>
        {reviews && reviews.images && reviews.images.length && (
        <div className="nw-review-subheaderviewreview">
          {REVIEW.PHOTO}
        </div>
        )}
        {reviews && reviews.images && reviews.images.length && (
          <div className="nw-customer-uploadedimagecontainer">
            {reviews.images &&
              reviews.images.map(image => (
                <img
                  className="nw-review-viewcustomerimage "
                  src={image.thumbnail}
                  alt="nnnow"
                />
              ))}
          </div>
        )}

        {reviews && reviews.text && reviews.text.length && (
          <div className="nw-review-subheaderviewreview">
            {REVIEW.REVIEW}
          </div>
        )}
        {reviews && reviews.text && reviews.text.length && (
          <textarea
            className="nw-review-viewtextarea"
            rows="10"
            cols="50"
            spellCheck="false"
            value={reviews.text}
            readOnly="yes"
          ></textarea>
        )}
        <div className="nw-review-editbutton">
        <Button
          className="nw-review-editreviewbutton"
          disabled={!updateReview}
          onClick={event => this.props.updateReviews(event)}
        >
          {REVIEW.EDIT_REVIEW}
        </Button>
        </div>
      </div>
    );
  }
}

ViewReviewPage.wrappedComponent.propTypes = {
  ReviewStore: PropTypes.shape({
    updateReview: PropTypes.func.isRequired
  }).isRequired
};

const getFinalComponent = component =>
  inject("ReviewStore")(observer(component));

const ProjectComponent = {
  getFinalComponent,
  wrapper: ViewReviewPage.wrappedComponent,
  component: ViewReviewPage
};

export default ProjectComponent;
